// extracted by mini-css-extract-plugin
module.exports = {"tags__inner":"bq_h8","tags":"bq_h9","tags__label":"bq_jb","tags_negative":"bq_jc"};